import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Mail, Lock, ArrowRight, MapPin } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const Login = () => {
    const { login, googleLogin } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        const r = await login({ email, password });
        if (!r.ok) return toast.error(r.error);
        toast.success("Welcome back!");
        navigate("/my-bookings");
    };
    const onGoogle = async () => {
        const r = await googleLogin();
        if (!r.ok) return toast.error(r.error);
        toast.success("Signed in with Google.");
        navigate("/my-bookings");
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center py-16 px-4" data-testid="login-page">
            <div className="w-full max-w-md bg-white border border-cream-200 rounded-2xl p-8 shadow-sm">
                <Link to="/" className="flex items-center gap-2 mb-6">
                    <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-saffron-500 to-saffron-600 flex items-center justify-center text-white">
                        <MapPin className="w-5 h-5" />
                    </div>
                    <span className="font-display text-2xl font-semibold text-ink">South<span className="text-saffron-500">Trip</span></span>
                </Link>
                <h1 className="font-display text-3xl text-ink">Welcome back</h1>
                <p className="text-ink-light text-sm mt-1">Sign in to manage your Kerala bookings.</p>

                <button onClick={onGoogle} className="mt-6 w-full px-4 py-3 rounded-xl border border-cream-200 hover:border-saffron-300 flex items-center justify-center gap-2 font-semibold text-ink text-sm transition" data-testid="login-google">
                    <svg width="18" height="18" viewBox="0 0 18 18">
                        <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"/>
                        <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.836.86-3.048.86-2.344 0-4.328-1.583-5.036-3.71H.957v2.332A8.997 8.997 0 0 0 9 18z"/>
                        <path fill="#FBBC05" d="M3.964 10.708A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.708V4.96H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.04l3.007-2.332z"/>
                        <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.96L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"/>
                    </svg>
                    Continue with Google
                </button>

                <div className="my-5 flex items-center gap-3 text-xs text-ink-light">
                    <span className="flex-1 h-px bg-cream-200" /> OR <span className="flex-1 h-px bg-cream-200" />
                </div>

                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <label className="text-xs font-semibold uppercase tracking-wider text-ink-light">Email</label>
                        <div className="relative mt-1">
                            <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-ink-light" />
                            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full pl-9 pr-3 py-2.5 rounded-lg border border-cream-200 bg-white" placeholder="you@example.com" data-testid="login-email" />
                        </div>
                    </div>
                    <div>
                        <label className="text-xs font-semibold uppercase tracking-wider text-ink-light">Password</label>
                        <div className="relative mt-1">
                            <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-ink-light" />
                            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full pl-9 pr-3 py-2.5 rounded-lg border border-cream-200 bg-white" data-testid="login-password" />
                        </div>
                    </div>
                    <button type="submit" className="w-full px-5 py-3 rounded-xl bg-saffron-500 hover:bg-saffron-600 text-white font-semibold transition shadow-md flex items-center justify-center gap-2" data-testid="login-submit">
                        Sign in <ArrowRight className="w-4 h-4" />
                    </button>
                </form>
                <p className="mt-5 text-sm text-center text-ink-light">
                    New to SouthTrip? <Link to="/register" className="text-saffron-600 font-semibold">Create an account</Link>
                </p>
            </div>
        </div>
    );
};

export default Login;
